var React = require('react');

function Flickr (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"128","height":"128","rx":"20","fill":"#fff","key":0}),React.createElement("g",{"transform":"matrix(.91525 0 0 .91525 5.4661 5.4733)","key":1},[React.createElement("path",{"d":"m5.5 64.585c0-15.466 12.45-27.915 27.916-27.915 15.465 0 27.914 12.449 27.914 27.915 0 15.465-12.449 27.915-27.914 27.915-15.466 0-27.916-12.45-27.916-27.915z","fill":"#005de1","key":0}),React.createElement("path",{"d":"m67.67 64.585c0-15.466 12.45-27.916 27.916-27.916 15.465 0 27.914 12.45 27.914 27.916 0 15.465-12.45 27.915-27.915 27.915-15.466 0-27.915-12.45-27.915-27.915z","fill":"#ff007e","key":1})])]);
}

Flickr.defaultProps = {"width":"128px","height":"128px","version":"1.1","viewBox":"0 0 128 128"};

module.exports = Flickr;

Flickr.default = Flickr;
